import React, { useState } from "react";
import dayjs from '../../utils/dayjs-setup';
import { Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, GridLegacy as Grid, MenuItem, Select, Stack, Typography } from '@mui/material';
import { DateFormatString, DateTimeFormatString, EstadosItemsAlistamiento, EstadosPedido, FormatPrice, getStatusPedido } from "../../utils/constants";
import { red } from "@mui/material/colors";




const ProductItemPedido = (props)=>{


    const statusAlistamiento = getStatusPedido({cantidad:props.cantidad,cantidad_inv:props.cantidad_inv});

    return <Card>
        <CardContent>
            <Grid container >
                <Grid items md={12} >
                    <Typography variant='p' >
                          {props.nombre_producto} - {props.calidad_producto} 
                    </Typography>
                </Grid>
                <Grid item md={6} sm={12} xs={12} >
                
                <Stack direction={"row"} >
                <Typography variant='p' >
                    Cantidad pedida: 
                </Typography>
                 <Chip color="success" size="small" label={`${FormatPrice(props.cantidad,2)} ${props.cod_erp_unidad_medida}`} />
                </Stack>
               
            </Grid>
            <Grid item md={6} sm={12} xs={12} >
            <Stack direction={"row"} >
                <Typography variant='p' >
                    Cantidad alistada: 
                </Typography>
                 <Chip color={ EstadosItemsAlistamiento[statusAlistamiento]?.color } size="small" label={`${[null,''].includes( props.cantidad_inv )?'SIN ALISTAR': FormatPrice(props.cantidad_inv,2)+' '+props.cod_erp_unidad_medida} `} />
                </Stack>
            </Grid>
             
             <Grid items md={6} >
                
                <Typography variant='p' >
                    <strong>P.V BASE:</strong> $ {FormatPrice(props.precio_unitario,2)} X {props.cod_erp_unidad_medida} 
                </Typography>
             </Grid>
             <Grid items md={6} >
                
                <Typography variant='p' >
                   <strong>DESC:</strong> $ {FormatPrice(props.vlr_descuentos,2)} X {props.cod_erp_unidad_medida} 
                </Typography>
             </Grid>
             <Grid items md={12} >
                
                <Typography variant='p' >
                    <strong>P.V FINAL:</strong> $ {FormatPrice(props.vlr_neto,2)} X {props.cod_erp_unidad_medida} 
                </Typography>
             </Grid>
                <Grid items md={6} >
                    <Typography variant='p' >
                    <strong>SUBTOTAL:</strong> $ {FormatPrice( props.vlr_subtotal,2 )} 
                    </Typography>
                </Grid>
                <Grid items md={6} >
                
                    <Typography variant='p' >
                    <strong>V. TOTAL:</strong> $ {FormatPrice( props.vlr_subtotal,2 )} 
                    </Typography>
                </Grid>
                <Grid items md={12} >
                
                <Typography sx={{color:red[500]}} variant='p' >
                    
                    Criterios de aceptacion: {props.observacion ||  props.criterio_aceptacion || 'No aplica'}
                </Typography>
            </Grid>
            </Grid>
        </CardContent>
        
    </Card>

}


export const ModalVerPedidos = ({
    visibleModal,
    productInfo={},
    onCloseModal=()=>{},
    estadosPedidos=[],
    onUpdateStatusRequest
})=> {


 
    const OnUpdateStatus = (action)=>{
        onUpdateStatusRequest({
            cod_pedido:productInfo.cod,
            action,
            productInfo
        });
    }

    return (
        <Dialog
        open={visibleModal}
        >
            <DialogTitle>
                Detalle del pedido
            </DialogTitle>
            <DialogContent>
                <Grid container  >
                    <Grid items sm={12} md={12} >
                    <Typography variant='p'  > 
                          <strong>Cliente:</strong> {productInfo.nombre_cliente}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                          <strong>Centro de operacion:</strong> {productInfo.centro_operacion}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                          <strong>Municipio:</strong> {productInfo.municipio_descripcion}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>Direccion:</strong> {productInfo.sucursal_direccion}
                        </Typography>
                    </Grid>
                    <Grid items sm={6} md={6} >
                        <Typography variant='p' > 
                           <strong>Celular 1:</strong> {productInfo.celular_notificaciones}
                        </Typography>
                    </Grid>
                    <Grid items sm={6} md={6} >
                        <Typography variant='p' > 
                           <strong>Celular 2:</strong> {productInfo.sucursal_telefono}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>Fecha de entrega:</strong> {dayjs(productInfo.fecha_entrega).format(DateTimeFormatString)}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>Condicion de pago:</strong> {productInfo.medio_pago_nombre}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>Punto de entrega:</strong> {productInfo.sucursal_direccion}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>Condicion de entrega: </strong>{productInfo.tipo_entrega_descripcion_corta} - {productInfo.tipo_entrega_descripcion}
                        </Typography>
                    </Grid>
                    <Grid>
                        <strong>Estado :</strong> <Chip color={EstadosPedido[productInfo.estado_nombre].color} label={EstadosPedido[productInfo.estado_nombre]?.label} />
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>VALOR TOTAL:</strong> $ {FormatPrice(productInfo.total_valor_pedido)} COP
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' > 
                           <strong>CODIGO ERP: </strong>{productInfo.pedido_cod_erp}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} sx={{marginTop:'15px',}} >
                        <Typography variant="p" fontSize={'1rem'} fontWeight={"bold"} >
                            Listado de productos
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        {
                            productInfo.detalle_pedido?.map(pedido_item=><ProductItemPedido
                                {...pedido_item}
                                />)
                        }
                    </Grid>
                    <Grid items sm={12} md={12} >
                         <Stack direction={"row"} alignItems={"end"} alignContent={"end"} justifyContent={"end"} spacing={1} marginTop={'10px'} >
                           
                            {
                               ["CREADO","RECIBIDO"].includes(productInfo.estado_nombre) && productInfo.tipo_pedido === 'PEDIDO' &&
                                <Button onClick={e=>OnUpdateStatus('CANCELADO')} variant="contained" size="small" color="error" >Cancelar pedido</Button>
                            }
                             {
                                productInfo.estado_nombre === 'CREADO' && productInfo.tipo_pedido === 'PEDIDO' && 
                                <Button onClick={e=>OnUpdateStatus('RECIBIDO')} variant="contained" size="small" color="primary" >Confirmar pedido</Button>
                            }
                            {
                                productInfo.estado_nombre === 'RECIBIDO' && productInfo.tipo_pedido === 'PEDIDO' && 
                                <Button onClick={e=>OnUpdateStatus('EN-ALISTAMIENTO')} variant="contained" size="small" color="primary" >Alistar pedido</Button>
                            }
                             {
                                productInfo.estado_nombre === 'EN-ALISTAMIENTO' && productInfo.tipo_pedido === 'PEDIDO' && 
                                <Button onClick={e=>OnUpdateStatus('ALISTADO')} variant="contained" size="small" color="primary" >Finalizar Alistamiento</Button>
                            }
                             {
                                productInfo.estado_nombre === 'ALISTADO' && productInfo.tipo_pedido === 'PEDIDO' && 
                                <Button onClick={e=>OnUpdateStatus('POR-FACTURAR')} variant="contained" size="small" color="primary" >Facturar</Button>
                            }
                            {
                                productInfo.estado_nombre === 'CREADO' && productInfo.tipo_pedido === 'COTIZACION' && 
                                <Button onClick={e=>OnUpdateStatus('RECIBIDO')} variant="contained" size="small" color="primary" >CONVERTIR A PEDIDO</Button>
                            }
                           
                         </Stack>
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button type="button" onClick={onCloseModal} variant='contained' color='secondary' >Cerrar ventana</Button>
            </DialogActions>
        </Dialog>
    )

}